const STORAGE_KEY = 'vbbplay.referral_code';

function normalizeRef(raw: string | null | undefined): string | null {
  if (!raw) return null;
  let text = String(raw).trim();
  if (!text) return null;
  if (text.toLowerCase().startsWith('ref_')) text = text.slice(4);
  text = text.trim();
  return text || null;
}

export function captureReferralFromUrl(search: string = window.location.search): string | null {
  try {
    const params = new URLSearchParams(search);
    const fromQuery = normalizeRef(params.get('ref') || params.get('referral') || params.get('start'));
    const fromTg = normalizeRef(params.get('tgWebAppStartParam'));
    const fromBotStart = normalizeRef(readTelegramStartParam());
    const raw = fromQuery || fromTg || fromBotStart || getStoredReferralCode();
    if (!raw) return null;
    localStorage.setItem(STORAGE_KEY, raw);
    return raw;
  } catch {
    return null;
  }
}

export function readTelegramStartParam(): string | null {
  try {
    const tg = window.Telegram?.WebApp as
      | { initDataUnsafe?: { start_param?: string } }
      | undefined;
    return tg?.initDataUnsafe?.start_param || null;
  } catch {
    return null;
  }
}

export function getStoredReferralCode(): string | null {
  try {
    return normalizeRef(localStorage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
}

export function clearStoredReferralCode(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
